import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _ExpandRightLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", d: "m9 6 6 6-6 6" }) }) });
}
const ExpandRightLight = forwardRef(_ExpandRightLight);
export { ExpandRightLight };
